module.exports = __webpack_public_path__ + "img/1.9.B.3fbfac26.png";